<template>
    <modalComponent show="show">
        <div class="modal-header">
            <h5 class="modal-title">Medical Records</h5>
            <button type="button" class="btn btn-close" data-bs-dismiss="modal" v-on:click="close()">
            </button>
        </div>
            <div class="modal-body pb-0">
                <div class="timing-modal">
                    <div class="form-group">
                        <label>Code <span class="text-danger">*</span></label>
                        <input type="text" readonly class="form-control" v-model="medicalRecords.code">
                    </div>
                    <div class="form-group">
                        <label>Date <span class="text-danger">*</span></label>
                        <input type="date" class="form-control" v-model="medicalRecords.date">
                    </div>
                    <div class="form-group">
                        <label>Description</label>
                        <textarea class="form-control" v-model="medicalRecords.description"></textarea>
                    </div>
                    <div class="form-group" style="padding: 10px 0 !important;"
                        v-if="medicalRecord.attachmentList.length > 0">
                        <button v-on:click="Attachment()" type="button"
                            class="btn btn-light btn-square btn-outline-dashed mb-1"><i
                                class="fas fa-cloud-upload-alt"></i>
                            View Attachment </button><span><b>Total {{ medicalRecord.attachmentList.length }}</b></span>
                    </div>
                    <div class="form-group" style="padding: 10px 0 !important;" v-else>
                        <button v-on:click="Attachment()" type="button"
                            class="btn btn-light btn-square btn-outline-dashed mb-1"><i
                                class="fas fa-cloud-upload-alt"></i>
                            Add Attachment </button>
                    </div>


                </div>
                <div class="model-footer">
                    <div class="modal-btn text-end pb-3">
                        <a href="#" class="btn btn-md btn-dark rounded-pill" v-on:click="close()">Cancel</a>
                        <button type="submit" class="btn btn-primary-gradient rounded-pill"
                            @click="SaveMedicalRecords()" v-bind:disabled="v$.medicalRecords.$invalid">Submit</button>
                    </div>
                </div>
            </div>
        

        <loading v-model:active="loading" :can-cancel="false" :is-full-page="true"></loading>
        <bulk-attachment :attachmentList="medicalRecords.attachmentList" :show="show1" v-if="show1"
            @close="attachmentSave" />
    </modalComponent>
</template>
<script>
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/css/index.css';
import useVuelidate from '@vuelidate/core';
import { required } from '@vuelidate/validators';
import moment from "moment";
export default {
    props: ['show', 'medicalRecord', 'type'],
    components: {
        Loading
    },
    setup() {
        return { v$: useVuelidate() }
    },
    data: function () {
        return {
            render: 0,
            loading: false,
            medicalRecords: this.medicalRecord,
            image: "",
            show1: false
        }
    },
    validations() {
        return {
            medicalRecords: {
                code: {
                    required
                },
                date: {
                    required
                },

            },
        }
    },
    methods: {
        close: function () {
            this.$emit('close');
        },
        Attachment: function () {
            this.show1 = true;
        },
        attachmentSave: function (attachment) {
            this.medicalRecords.attachmentList = attachment;
            this.show1 = false;
        },
        GetAutoCodeGenerator: function () {

            var root = this;
            var token = '';
            if (token == '') {
                token = localStorage.getItem('token');
            }
            this.$https.get('/MedicalRecords/GetAutoMedicalRecordsCode', { headers: { "Authorization": `Bearer ${token}` } }).then(function (response) {

                if (response.data != null) {
                    root.medicalRecords.code = response.data.data;
                    root.render++;
                }
            });
        },
        uploadImage() {
            var root = this;
            var file = this.$refs.imgupload.files;

            this.filePath = null;
            var fileData = new FormData();
            this.image = URL.createObjectURL(this.$refs.imgupload.files[0]);
            // convert file into FormData object
            for (var k = 0; k < file.length; k++) {
                fileData.append("files", file[k]);
            }
            root.medicalRecords.fileName = file[0].name;

            this.$https.post('/Home/UploadFilesAsync', fileData)
                .then(function (response) {
                    if (response.data != null) {
                        root.medicalRecords.filePath = response.data;
                    }
                });
        },
        SaveMedicalRecords: function () {
           
            var root = this;
            this.loading = true;
            var token = '';
            if (token == '') {
                token = localStorage.getItem('token');
            }
            this.$https.post('/MedicalRecords/SaveMedicalRecords', this.medicalRecords, { headers: { "Authorization": `Bearer ${token}` } })
                .then(function (response) {
                    if (response.data.isSuccess == true) {
                        root.$swal.fire({
                            title: 'Saved',
                            text: response.data.commonMessage,
                            type: 'success',
                            icon: 'success',
                            showConfirmButton: false,
                            timer: 1500,
                            timerProgressBar: true,
                        });

                        root.close();

                    }
                    else {
                        root.$swal.fire({
                            title: 'Error!',
                            text: response.data.commonMessage,
                            type: 'error',
                            icon: 'error',
                            showConfirmButton: false,
                            timer: 1500,
                            timerProgressBar: true,
                        });
                    }
                })
                .catch(error => {
                    console.log(error)
                    root.$swal.fire(
                        {
                            icon: 'error',
                            title: 'Something Went Wrong!',
                            text: error.response.data,

                            showConfirmButton: false,
                            timer: 5000,
                            timerProgressBar: true,
                        });

                    root.loading = false
                })
                .finally(() => root.loading = false);
        }
    },
    mounted: function () {
        if (this.medicalRecords.id == '00000000-0000-0000-0000-000000000000') {
            this.GetAutoCodeGenerator();
        }
        if (this.medicalRecords.id != '00000000-0000-0000-0000-000000000000') {
            this.medicalRecords.date = moment(this.medicalRecords.date).format('YYYY-MM-DD')
        }
        this.medicalRecords.patientId = localStorage.getItem("UserID");
    }
}
</script>